exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes fade-in---2OQsn{0%{opacity:0}100%{opacity:1}}.footer---380IS{animation:fade-in---2OQsn 1s ease-in;height:80px;display:flex;align-items:flex-start;z-index:100;max-width:1200px;width:100%;margin:0 auto}.footer---380IS .activity-side---fyp27{display:flex;justify-content:space-between;width:calc(100% - 264px);margin:0 5px 0 40px}.footer---380IS .activity-side---fyp27 .misc-container---3qlhw{z-index:1;display:flex;align-items:center}.footer---380IS .activity-side---fyp27 .misc-container---3qlhw .info-feedback-margin---11TYx{margin-left:20px}.footer---380IS .activity-side---fyp27 .btn-cont---2Np7-{display:flex;margin-left:20px}.footer---380IS .progress-side---1SSu0{width:174px;margin:0 40px 0 5px;display:flex;justify-content:center}.footer---380IS.question---2_Jkn .btn-cont---2Np7-{display:none}.footer---380IS.question---2_Jkn .progress-side---1SSu0 .btn---PrdCH{display:none}", ""]);

// exports
exports.locals = {
	"footer": "footer---380IS",
	"fade-in": "fade-in---2OQsn",
	"activity-side": "activity-side---fyp27",
	"misc-container": "misc-container---3qlhw",
	"info-feedback-margin": "info-feedback-margin---11TYx",
	"btn-cont": "btn-cont---2Np7-",
	"progress-side": "progress-side---1SSu0",
	"question": "question---2_Jkn",
	"btn": "btn---PrdCH"
};